export default "__VITE_ASSET__DZ6PSs4G__"